// extracted by mini-css-extract-plugin
export default {"productGrid":"Qca-z","centerLink":"Rca-z","productSection":"Sca-z","item":"Tca-z","ctaButton":"Uca-z"};